import { render, staticRenderFns } from "./CouponShow.vue?vue&type=template&id=6cf55396&scoped=true&"
import script from "./CouponShow.vue?vue&type=script&lang=js&"
export * from "./CouponShow.vue?vue&type=script&lang=js&"
import style0 from "./CouponShow.vue?vue&type=style&index=0&id=6cf55396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf55396",
  null
  
)

export default component.exports